// react
import React from 'react';
import { useSelector } from 'react-redux';
import { getUserInfoRedux } from 'reducers/Login/selector';
// temp datasource
import HistoryIcon from '@material-ui/icons/History';
import Announcement from './Announcement';
var HomepageRWD = function () {
    var userInfo = useSelector(getUserInfoRedux);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "homepageheader" },
            React.createElement("div", { className: "homepageheaderinfo" },
                React.createElement("div", null,
                    React.createElement("p", null,
                        "\u89AA\u611B\u7684 ",
                        userInfo.userName,
                        " \u60A8\u597D\uFF01"),
                    React.createElement("p", { className: "small" }, " \u6B61\u8FCE\u4F7F\u7528"),
                    " ",
                    React.createElement("h1", null, "\u96FB\u5B50\u5546\u52D9\u901A\u95DC\u5E73\u53F0"),
                    React.createElement("div", { className: "info", style: { marginTop: '10px', color: '#333', fontSize: '14px' } },
                        React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: '4px' } },
                            userInfo.currentLogin && (React.createElement("div", { style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    position: 'relative',
                                    paddingLeft: '28px',
                                } },
                                React.createElement("div", { style: {
                                        position: 'absolute',
                                        left: '0px',
                                        display: 'flex',
                                        fontSize: '1.6em',
                                    } },
                                    React.createElement(HistoryIcon, null)),
                                React.createElement("div", { style: { fontWeight: 'bold' } }, userInfo.currentLogin))),
                            userInfo.lastLogin && (React.createElement("div", { style: { color: '#666', paddingLeft: '28px' } }, userInfo.lastLogin))))))),
        React.createElement(Announcement, null)));
};
export default HomepageRWD;
